import { render } from "./NewVacancyVideoPage.vue?vue&type=template&id=767dc168&scoped=true"
import script from "./NewVacancyVideoPage.vue?vue&type=script&lang=js"
export * from "./NewVacancyVideoPage.vue?vue&type=script&lang=js"

import "./NewVacancyVideoPage.vue?vue&type=style&index=0&id=767dc168&scoped=scoped&lang=css"

import exportComponent from "C:\\Users\\PR024\\Desktop\\uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767dc168"]])

export default __exports__